export const MODAL_TITLE = 'Actualizar foto de perfil';

export const MODAL_CLOSE_BTN = 'Cerrar';

export const MODAL_CANCEL_BTN = 'Cancelar';

export const MODAL_SAVE_BTN = 'Guardar';

export const MODAL_OK_BTN = 'Ok';

export const BUTTON_LOAD_IMG = 'Cargar imagen';

export const BUTTON_REMOVE_IMG = 'Borrar imagen';

export const SYMBOLS = {
  MINUS: '-',
  PLUS: '+',
};

export const ACCEPTED_IMG_TYPES = 'image/jpg,image/jpeg,image/png';

export const MB_LIMIT_FILES = 10;

export const WARNING_MSG_TITLE = '¡Ups!';

export const WARNING_MSG_DESC = ['Tienes cambios sin guardar. ', '¿Seguro que deseas cancelar?'];

export const ERROR_MSG_TITLE = 'Error';

export const ERROR_MSG_DESC = [
  'Se produjo un error de aplicación. Inténtalo de nuevo más tarde o informa al servicio técnico si el problema continúa ocurriendo.',
];
